/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import City from "../../components/City";

const AdminCity = (props) => {
    return (
        <City moduleType={'Admin'}  {...props}/>
    )
}

export default AdminCity